import { UserModel } from "./UserModel";

/**Модель родительской задачи очереди */
export class QueueRelationParentTaskModel {
  /**ID задачи */
  TaskId!: number;
  /**ID неймспейса */
  NamespaceId!: string;
  /**ID очереди */
  QueueId!: string;
  /**ID проекта */
  ProjectId!: number;
  /**Автор задачи */
  Author!: UserModel;
  /**Есть ли у пользователя доступ к родительской задаче */
	Access: boolean = false;

  constructor(obj?: Partial<QueueRelationParentTaskModel>) {
    Object.assign(this, obj);
  }
}
